<template>
    <Carousel class="bg-slate-50">
        <template #header>
            <div class="flex items-center">
                <span class="flex-initial icon icon-flashcards w-8 h-8 mr-2"></span>
                <h2 class="flex-1 font-subtitle-3 md:font-subtitle-2 line-clamp-2 break-word-please">
                    {{ item.h2 }}
                </h2>
            </div>
        </template>
        <template #slides>
            <div
                v-for="flashcardsSet in item.data"
                :key="flashcardsSet.id"
                class="bg-white min-w-80 pt-4 px-4 pb-2 my-1 shadow rounded-lg md:min-w-84"
            >
                <div class="flex mb-3">
                    <a
                        :href="flashcardsSet.link"
                        :alt="flashcardsSet.h3"
                        class="flex-none mr-4"
                        ><div
                            class="preview flex items-end justify-center flex-shrink-0 w-18 h-18 md:h-24 md:w-24 bg-cover border border-slate-100"
                        >
                            <picture>
                                <div
                                    class="preview flex items-end justify-center flex-shrink-0 w-18 h-18 md:h-24 md:w-24 bg-cover border border-slate-100"
                                >
                                    <div
                                        class="text-slate-400 text-center leading-none text-2xs md:text-xs bg-white border rounded-full shadow px-2 py-1 mb-1 md:mb-3"
                                    >
                                        {{ flashcardText(flashcardsSet) }}
                                    </div>
                                </div>
                            </picture>
                        </div>
                    </a>
                    <div>
                        <h3 class="text-blue-600 text-base font-normal line-clamp-2 leading-6 mb-1 break-word-please">
                            <a
                                :href="flashcardsSet.link"
                                :alt="flashcardsSet.h3"
                            >
                                {{ flashcardsSet.h3 }}
                            </a>
                        </h3>
                        <p class="h-15 text-sm text-slate-400 line-clamp-3 leading-5 break-word-please">
                            {{ flashcardsSet.text }}
                        </p>
                    </div>
                </div>
                <div class="flex justify-end text-sm text-slate-400 leading-5 pt-2 border-t">
                    <div class="flex items-center ml-4">
                        <span class="icon icon-heart h-5 w-5 mr-1"></span>
                        <span>{{ flashcardsSet.up_votes || 0 }}</span>
                    </div>
                    <div class="flex items-center ml-4">
                        <span class="icon icon-play h-5 w-5 mr-1"></span>
                        <span>{{ flashcardsSet.visits || 0 }}</span>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <WidgetFooter
                :text="item.text"
                :button-link="item.button_link"
                :button-target="item.button_target"
                :button-text="item.button_text"
            ></WidgetFooter>
        </template>
    </Carousel>
</template>

<script>
import Carousel from '@/components/Carousel';
import WidgetFooter from './WidgetFooter.vue';

export default {
    name: 'FlashcardsWidget',
    components: { WidgetFooter, Carousel },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    i18nOptions: {
        namespaces: ['course'],
    },
    methods: {
        flashcardText(flashcardsSet) {
            const cards = flashcardsSet.amount_cards;
            if (cards === 1) {
                return `${cards} ${this.$t('results.item.fc-singular')}`;
            }
            return `${cards} ${this.$t('results.item.fc-plural')}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.h-15 {
    height: 3.75rem;
}
@screen md {
    .md\:w-84 {
        width: 21rem;
    }
}
.preview {
    background-image: url(/images/placeholders/flashcards_preview.svg);
}
</style>
